// UNICO punto di configurazione degli ambienti.
// Ogni ambiente definisce ENTRAMBI i backend insieme, cosi' restano sempre coerenti:
//   - bk   = backend gestionale (dominio: bolle, prodotti, giacenze, ...)
//   - menu = micro-servizio auth/menu (login, refresh, menu, rotte)
//
// Per cambiare ambiente: modificare `AMBIENTE_ATTIVO` qui sotto,
// oppure a build-time con REACT_APP_AMBIENTE (es. REACT_APP_AMBIENTE=produzione npm run build),
// oppure forzare i singoli URL con REACT_APP_API_BK / REACT_APP_API_MENU.

const ambienti = {
  // Ambiente ATTIVO in questa installazione: backend DENTRO la cartella del progetto
  // (bk su 4021, bkMenu su 4020, sulla stessa macchina 192.168.255.52).
  sviluppo: {
    menu: 'http://192.168.255.52:4020/',
    bk:   'http://192.168.255.52:4021/',
    //bk:   'https://logisticaapi.netoip.com/',
    //menu: 'https://logisticaapimenu.netoip.com/',
  },

  // ===== PRODUZIONE (server remoto netoip.com) =====
  produzione: {
    bk:   'https://logisticaapi.netoip.com/',
    menu: 'https://logisticaapimenu.netoip.com/',
  },

  // Altri ambienti storici (remoti) — lasciati per riferimento, non attivi:
  // test: { bk: 'https://apilogitest.netoip.com/',   menu: 'https://mnapilogitest.netoip.com/' },
  // mpm:  { bk: 'https://apimagazzino.mpmgroup.it/',  menu: 'https://apimenu.mpmgroup.it/' },
  // lan:  { bk: 'http://10.16.0.122:3003/',           menu: 'http://10.16.0.122:4005/' },
  // URL storici senza coppia definita:
  //   bk:   http://192.168.255.52:3003/ , http://192.168.1.39:4011/
  //   menu: http://192.168.255.52:4005/
};

const AMBIENTE_ATTIVO = process.env.REACT_APP_AMBIENTE || 'sviluppo';

const attivo = ambienti[AMBIENTE_ATTIVO] || ambienti.sviluppo;

const env = {
  bk:   process.env.REACT_APP_API_BK   || attivo.bk,
  menu: process.env.REACT_APP_API_MENU || attivo.menu,
};

export default env;
